import { RootState } from '../root.reducers';
import { UtimacoCircuitSwitch } from './utimacoCircuitSwitch.types';

export const getUtimacoCircuitSwitchList = (state: RootState): UtimacoCircuitSwitch[] =>
  state.utimacoCircuitSwitch.entities;

export const getUtimacoCircuitSwitch = (state: RootState): UtimacoCircuitSwitch | null =>
  state.utimacoCircuitSwitch.single;

export const getSelectedUtimacoCircuitSwitch = (state: RootState): UtimacoCircuitSwitch[] =>
  state.utimacoCircuitSwitch.selected;

export const getUtimacoCircuitSwitchCreatedId = (state: RootState): string | null =>
  state.utimacoCircuitSwitch.createdId;

export const isUtimacoCircuitSwitchCreatePopupOpen = (state: RootState): boolean =>
  state.utimacoCircuitSwitch.ui.isCreatePopupOpen;

export const isUtimacoCircuitSwitchLoading = (state: RootState): boolean =>
  state.utimacoCircuitSwitch.ui.isLoading;
